export const HOME = '/';
export const BINS = 'rack/:rackId/bins';
// export const BINS = 'bins/:id';
export const DELIVERIES = 'deliveries';
export const PICKLIST = 'pick-list';
export const SETTINGS = 'settings';
export const USER = 'user';
//
export const TOKENS = 'tokens';
export const SUPPORT = 'support';
export const ACCOUNT = 'account';
export const SIGNUP = 'signup';
export const SIGNUPCHANGEPASSWORD = 'set-password';
export const SIGNUPCOMPLETE = 'signup-complete';
export const SIGNIN = 'signin';
export const VERIFY_OTP = 'verify-otp';
export const RESET_PASSWORD = 'reset-password';
export const RESET_PASSWORD_VERIFY = 'reset-password/verify';
export const NOTFOUND = '404';
